import { render, staticRenderFns } from "./DashboardLayout.vue?vue&type=template&id=806248fa&scoped=true"
import script from "./DashboardLayout.vue?vue&type=script&lang=js"
export * from "./DashboardLayout.vue?vue&type=script&lang=js"
import style0 from "./DashboardLayout.vue?vue&type=style&index=0&id=806248fa&prod&lang=scss"
import style1 from "./DashboardLayout.vue?vue&type=style&index=1&id=806248fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806248fa",
  null
  
)

export default component.exports